import type { Item } from '../../../../types';

const itemDataKey: unique symbol = Symbol('item');

type ItemData = { index: number; item: Item; [itemDataKey]: true };

export function getItemData({ item, index }: { index: number; item: Item }): ItemData {
	return {
		[itemDataKey]: true,
		item,
		index,
	};
}

export function isItemData(data: Record<string | symbol, unknown>): data is ItemData {
	return data[itemDataKey] === true;
}
